import {
  GisFavoriteSynchronizationResult, Zone, ZoneApi, ZoneMutation, ZoneSuggestions, // eslint-disable-line no-unused-vars
} from '@clients/myTrips'
import { AxiosPromise } from 'axios' // eslint-disable-line no-unused-vars
import appendCredentials from '@util/appendCredentials'
import getBasePath from '@util/path'

let basePath = getBasePath() + '/my-trips'

export default class ExtendedZoneApi extends ZoneApi {
  getZones (options?: any): AxiosPromise<Array<Zone>> {
    const optionsParam = appendCredentials(options)
    optionsParam.basePath = basePath
    return super.getZones(undefined, optionsParam)
  }

  createZone (zoneCreateRequestBody: ZoneMutation, options?: any): AxiosPromise<Zone> {
    const optionsParam = appendCredentials(options)
    optionsParam.basePath = basePath
    return super.createZone(zoneCreateRequestBody, undefined, optionsParam)
  }

  getZone (id: number, options?: any): AxiosPromise<Zone> {
    const optionsParam = appendCredentials(options)
    optionsParam.basePath = basePath
    return super.getZone(id, undefined, optionsParam)
  }

  updateZone (id: number, zoneUpdateRequestBody: ZoneMutation, options?: any): AxiosPromise<Zone> {
    const optionsParam = appendCredentials(options)
    optionsParam.basePath = basePath
    return super.updateZone(id, zoneUpdateRequestBody, undefined, optionsParam)
  }

  deleteZone (id: number, options?: any): AxiosPromise<void> {
    const optionsParam = appendCredentials(options)
    optionsParam.basePath = basePath
    return super.deleteZone(id, undefined, optionsParam)
  }

  getZonesSuggestions (options?: any): AxiosPromise<ZoneSuggestions> {
    const optionsParam = appendCredentials(options)
    optionsParam.basePath = basePath
    return super.getZonesSuggestions(undefined, optionsParam)
  }

  triggerGisFavoriteSynchronization (options?: any): AxiosPromise<GisFavoriteSynchronizationResult> {
    const optionsParam = appendCredentials(options)
    optionsParam.basePath = basePath
    return super.triggerGisFavoriteSynchronization(undefined, optionsParam)
  }
}
